import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ReactSession } from 'react-client-session';
import { Provider } from 'react-redux';
import { persistor, store } from './store/store';

import Detail from './screens/Detail';
import Control from './screens/Control';
import Subscription from './screens/Subscription';
import Account from './screens/Account';
import Discover from './screens/Discover';
import PrivacyPolicy from './screens/PrivacyPolicy';
import ProfitCalculations from './screens/ProfitCalculations';
import { useSelector } from 'react-redux';
import { selectIsDev, selectUserId } from './store/slices/user';
import Overview from './screens/Overview';
import { PersistGate } from 'redux-persist/integration/react';
import Login from './screens/Login';
import Presentation from './screens/Presentation';

ReactSession.setStoreType('localStorage');
ReactSession.set('health', { isLoading: false, data: [] });

const container = document.getElementById('root');
const root = createRoot(container!);

const Root = () => {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <RoutesComponent />
        </PersistGate>
      </Provider>
    </React.StrictMode>,
  );
};

const RoutesComponent = () => {
  const isDev = useSelector(selectIsDev);
  const userId = useSelector(selectUserId);

  if (!userId) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<Login />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<Overview />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/sub" element={<Subscription />} />
        <Route path="/account" element={<Account />} />
        <Route path="/presentation" element={<Presentation />} />
        {isDev && <Route path="/control" element={<Control />} />}
        {isDev && (
          <Route path="/profitCalculations" element={<ProfitCalculations />} />
        )}
        <Route path="detail" element={<Detail />}>
          <Route
            path=":subscriptionId"
            element={
              <div>
                <Detail />
              </div>
            }
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

Root();
